import React, { useState, useEffect, useRef } from "react";
import validator from "validator";
import {
    getCountryByOrder, getCountryList,
    updateRecipient,
} from "../../../services/CommonService";
import {
    COUNTRY_CODE,
    COUNTRY_ICON,
    COUNTRY_ID,
} from "../../../configs/AppConfig";
import { recipientCreate } from "../../../services/Recipients";
import { toast } from "react-toastify";
import Utils from "../../../utils";

function ModifyRecipient(props) {
    const clsButtonRef = useRef(null);
    const countryDropdownRef = useRef(null);

    const [id, setId] = useState(0);
    const [countryCodeList, setCountryCodeList] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [countryIcon, setCountryIcon] = useState(COUNTRY_ICON);
    const [countryId, setCountryId] = useState(COUNTRY_ID);
    const [countryCode, setCountryCode] = useState(COUNTRY_CODE);
    const [mobile, setMobile] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [addressCountryId, setAddressCountryId] = useState("");
    const [zipcode, setZipcode] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);

    let errorObj = {
        first_name: "",
        last_name: "",
        email: "",
        mobile: "",
        company_name: "",
        address_1: "",
        address_2: "",
        city: "",
        state: "",
        address_country_id: "",
        zipcode: "",
    };
    const [errors, setErrors] = useState(errorObj);

    useEffect(() => {
        getCountryByOrder("code")
            .then((response) => {
                setCountryCodeList(response.data.data);
            })
            .catch((err) => {
            });

        getCountryList()
            .then((response) => {
                setCountryList(response.data.data);
            })
            .catch((err) => {
            });
    }, []);

    useEffect(() => {
        setId(props.data.id);
        setFirstName(props.data.first_name);
        setLastName(props.data.last_name);
        setEmail(props.data.email);
        setMobile(props.data.mobile);
        setCountryId(props.data.country_id);
        let index = countryList.findIndex(
            (x) => x.id === parseInt(props.data.country_id)
        );
        if (index > -1) {
            setCountryIcon(countryList[index]["icon"].toLowerCase());
            setCountryCode(countryList[index]["code"]);
        }
        setCompanyName(props.data.company_name);
        setAddress1(props.data.address_1);
        setAddress2(props.data.address_2);
        setCity(props.data.city);
        setState(props.data.state);
        setAddressCountryId(props.data.address_country_id);
        setZipcode(props.data.zipcode);
    }, [props?.data, countryList]);

    function handleCountry(e, obj) {
        e.preventDefault();
        let id = obj.id;
        let index = countryCodeList.findIndex((x) => x.id === parseInt(id));
        if (index > -1) {
            setCountryIcon(countryCodeList[index]["icon"].toLowerCase());
        }
        setCountryId(id);
        setCountryCode(obj.code);
        setSearchTerm("");
        if (countryDropdownRef.current) {
            countryDropdownRef.current.scrollTop = 0;
        }
    }

    const filteredCountries = countryCodeList.filter(country =>
        country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        country.code.toString().includes(searchTerm)
    );

    function handleRecipientAdd(e) {
        e.preventDefault();
        onRecipientStore(e, 2);
    }

    function handleRecipientSave(e) {
        e.preventDefault();
        onRecipientStore(e, 1);
    }

    function onRecipientStore(e, type) {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errors };

        if (!firstName) {
            errorObj.first_name = "First name must be required";
            error = true;
        }
        if (!lastName) {
            errorObj.last_name = "Last name must be required";
            error = true;
        }
        if (!email) {
            errorObj.email = "Email must be required";
            error = true;
        } else if (!validator.isEmail(email)) {
            errorObj.email = "Please enter valid email address";
            error = true;
        }

        if (mobile && mobile.length !== 10) {
            errorObj.mobile = "Mobile number must be 10 digits";
            error = true;
        }

        setErrors(errorObj);

        if (error) return;

        props.setLoading(true);
        let obj = {
            first_name: firstName,
            last_name: lastName,
            email: email,
            country_id: countryId,
            mobile: mobile,
            company_name: companyName,
            address_1: address1,
            address_2: address2,
            city: city,
            state: state,
            zip_code: zipcode,
            address_country_id: addressCountryId,
        };
        recipientCreate(obj)
            .then((response) => {
                if (type === 1) {
                    clsButtonRef.current?.click();
                }
                clearRecipientData();
                props.setIsEffect(!props.isEffect);
                toast.success(response.data.message);
                props.setLoading(false);
            })
            .catch((err) => {
                props.setLoading(false);
                toast.error(Utils.getErrorMessage(err));
            });
    }

    function handleRecipientUpdate(e) {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errors };

        if (!firstName) {
            errorObj.first_name = "First name must be required";
            error = true;
        }
        if (!lastName) {
            errorObj.last_name = "Last name must be required";
            error = true;
        }
        if (!email) {
            errorObj.email = "Email must be required";
            error = true;
        } else if (!validator.isEmail(email)) {
            errorObj.email = "Please enter valid email address";
            error = true;
        }

        if (mobile && mobile.length !== 10) {
            errorObj.mobile = "Mobile number must be 10 digits";
            error = true;
        }

        setErrors(errorObj);

        if (error) return;

        props.setLoading(true);
        let obj = {
            recipient_id: id,
            first_name: firstName,
            last_name: lastName,
            email: email,
            country_id: countryId,
            mobile: mobile,
            company_name: companyName,
            address_1: address1,
            address_2: address2,
            city: city,
            state: state,
            zip_code: zipcode,
            address_country_id: addressCountryId,
        };
        updateRecipient(obj)
            .then((response) => {
                clsButtonRef.current?.click();
                clearRecipientData();
                toast.success(response.data.message);
                props.setIsEffect(!props.isEffect);
                props.setLoading(false);
            })
            .catch((err) => {
                props.setLoading(false);
                toast.error(Utils.getErrorMessage(err));
            });
    }

    function onCloseRecipientModel(e) {
        e.preventDefault();
        clsButtonRef.current?.click();
        clearRecipientData();
    }

    function clearRecipientData() {
        let error = { ...errors };
        error.first_name = "";
        error.last_name = "";
        error.email = "";
        error.mobile = "";
        error.company_name = "";
        error.address_1 = "";
        error.address_2 = "";
        error.city = "";
        error.state = "";
        error.address_country_id = "";
        error.zipcode = "";
        setErrors(error);
        let obj = {
            id: 0,
            first_name: "",
            last_name: "",
            email: "",
            country_id: 227,
            mobile: "",
            company_name: "",
            address_1: "",
            address_2: "",
            city: "",
            state: "",
            address_country_id: "",
            zipcode: "",
            readonly: false,
        };
        props.setData(obj);
    }

    return (
        <div
            className="offcanvas offcanvas-end Add-Recipients "
            data-bs-scroll="true"
            tabIndex="-1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            id="addRecipients"
            aria-labelledby="addRecipientsLabel"
        >
            <div className="offcanvas-header">
                <h5 className={ props.data.readonly === false ? `offcanvas-title` : `d-none` } id="notification_boxLabel">{id > 0 ? `Edit Collaborator` : `Add Collaborator`}</h5>
                <h5 className={ props.data.readonly === true ? `offcanvas-title` : `d-none` } id="notification_boxLabel">View Collaborator</h5>
                <button type="button" ref={clsButtonRef} onClick={clearRecipientData} className="btn close_btn text-reset" data-bs-dismiss="offcanvas" aria-label="Close">
                    <i className="bi bi-x-circle" aria-hidden="true" />
                </button>
            </div>
            <div className="offcanvas-body">
                <form className="">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="mb-4">
                                <label htmlFor="first_name" className="form-label mb-2">
                                    First Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="first_name"
                                    value={firstName}
                                    readOnly={props.data.readonly}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    placeholder="Enter First Name"
                                    style={{ height: "40px" }}
                                />
                                {errors.first_name && (
                                    <div className="text-danger">{errors.first_name}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="mb-4">
                                <label htmlFor="last_name" className="form-label mb-2">
                                    Last Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="last_name"
                                    value={lastName}
                                    readOnly={props.data.readonly}
                                    onChange={(e) => setLastName(e.target.value)}
                                    placeholder="Enter Last Name"
                                    style={{ height: "40px" }}
                                />
                                {errors.last_name && (
                                    <div className="text-danger">{errors.last_name}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="mb-4">
                                <label htmlFor="email" className="form-label mb-2">
                                    Email <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="email"
                                    value={email}
                                    readOnly={props.data.readonly}
                                    onChange={(e) => setEmail(e.target.value.trim())}
                                    placeholder="Enter Email Address"
                                    style={{ height: "40px" }}
                                />
                                {errors.email && (
                                    <div className="text-danger">{errors.email}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="mb-4">
                                <label
                                    htmlFor="country_code"
                                    className="form-label mb-2 number"
                                >
                                    Mobile Number
                                </label>
                                <div className="country_code">
                                    <span className="d-flex align-items-center">
                                        <img
                                            src={`/images/flags/${countryIcon}.png`}
                                            className="me-2"
                                            alt="country"
                                        />
                                        <div className="dropdown w-100">
                                            <button
                                                className="btn btn-white dropdown-toggle w-100 text-start"
                                                type="button"
                                                id="dropdownMenuButton1"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                +{countryCode}
                                            </button>
                                            <ul
                                                className="dropdown-menu p-2"
                                                aria-labelledby="dropdownMenuButton1"
                                                style={{ maxHeight: "300px", width: "450px", overflowY: "auto" }}
                                                ref={countryDropdownRef}
                                            >
                                                <li className="mb-2">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Search country or code"
                                                        value={searchTerm}
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                        onClick={(e) => e.stopPropagation()}
                                                    />
                                                </li>
                                                {filteredCountries.length > 0 ? (
                                                    filteredCountries.map((item, index) => (
                                                        <li
                                                            key={index}
                                                            className="cur-pointer"
                                                            onClick={(e) => handleCountry(e, item)}
                                                        >
                                                            <div className="dropdown-item d-flex align-items-center">
                                                                <img
                                                                    src={`/images/flags/${item.icon}.png`}
                                                                    alt={item.name}
                                                                    width="20"
                                                                    className="me-2"
                                                                />
                                                                <div className="country-name me-2">{item.name}</div>
                                                                <div className="country-code ms-auto">+{item.code}</div>
                                                            </div>
                                                        </li>
                                                    ))
                                                ) : (
                                                    <li className="dropdown-item text-muted">No countries found</li>
                                                )}
                                            </ul>
                                        </div>
                                    </span>
                                    <input
                                        type="tel"
                                        className="form-control"
                                        id="country_code"
                                        value={mobile}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, '');
                                            setMobile(value);
                                            if (errors.mobile && value.length === 10) {
                                                setErrors({ ...errors, mobile: "" });
                                            }
                                        }}
                                        onBlur={() => {
                                            if (mobile && mobile.length !== 10) {
                                                setErrors((prev) => ({ ...prev, mobile: "Mobile number must be 10 digits" }));
                                            }
                                        }}
                                        readOnly={props.data.readonly}
                                        placeholder="Mobile Number"
                                        style={{ height: "40px" }}
                                        maxLength={10}
                                    />
                                </div>
                                {errors.mobile && (
                                    <div className="text-danger">{errors.mobile}</div>
                                )}
                            </div>
                        </div>
                    </div>
                </form>
                <div className="accordion more--details" id="More_details">
                    <div className="accordion-item border bg-blue">
                        <h2 className="accordion-header bg-blue " id="moreDetails">
                            <button
                                className={`accordion-button ${isAccordionOpen ? "" : "collapsed"}`}
                                style={{ boxShadow: "none" }}
                                type="button"
                                onClick={() => setIsAccordionOpen(!isAccordionOpen)}
                            >
                                More Details
                            </button>


                        </h2>
                        <div
                            id="More-details"
                            className={`accordion-collapse collapse ${isAccordionOpen ? "show" : ""}`}

                        >
                            <div className="accordion-body px-0">
                                <form className="mx-3">
                                    <div className="mb-4">
                                        <label htmlFor="email_subject" className="form-label mb-3">
                                            Company Name
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="company_name"
                                            value={companyName}
                                            onChange={(e) => setCompanyName(e.target.value)}
                                            readOnly={props.data.readonly}
                                            placeholder="Enter Company Name"
                                            style={{ height: "40px" }}
                                        />
                                        {errors.company_name && (
                                            <div className="text-danger">{errors.company_name}</div>
                                        )}
                                    </div>
                                    <div className="mb-0">
                                        <label htmlFor="email_subject" className="form-label mb-3">
                                            Address
                                        </label>
                                        <input
                                            type="address"
                                            className="form-control"
                                            id="address_1"
                                            value={address1}
                                            onChange={(e) => setAddress1(e.target.value)}
                                            readOnly={props.data.readonly}
                                            placeholder="Address line 1"
                                            style={{ height: "40px" }}
                                        />
                                        {errors.address_1 && (
                                            <div className="text-danger">{errors.address_1}</div>
                                        )}
                                        <input
                                            type="address"
                                            className="form-control mt-2"
                                            id="address_2"
                                            value={address2}
                                            onChange={(e) => setAddress2(e.target.value)}
                                            readOnly={props.data.readonly}
                                            placeholder="Address line 2"
                                            style={{ height: "40px" }}
                                        />
                                        {errors.address_2 && (
                                            <div className="text-danger">{errors.address_2}</div>
                                        )}
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <input
                                                    type="text"
                                                    className="form-control mt-2"
                                                    id="city"
                                                    value={city}
                                                    onChange={(e) => setCity(e.target.value)}
                                                    readOnly={props.data.readonly}
                                                    placeholder="City"
                                                    style={{ height: "40px" }}
                                                />
                                                {errors.city && (
                                                    <div className="text-danger">{errors.city}</div>
                                                )}
                                            </div>
                                            <div className="col-lg-6">
                                                <input
                                                    type="text"
                                                    className="form-control mt-2"
                                                    id="state"
                                                    value={state}
                                                    onChange={(e) => setState(e.target.value)}
                                                    readOnly={props.data.readonly}
                                                    placeholder="State"
                                                    style={{ height: "40px" }}
                                                />
                                                {errors.state && (
                                                    <div className="text-danger">{errors.state}</div>
                                                )}
                                            </div>
                                            <div className="col-lg-6">
                                                <select
                                                    className="form-select mt-2"
                                                    value={addressCountryId}
                                                    disabled={props.data.readonly}
                                                    onChange={(e) => setAddressCountryId(e.target.value)}
                                                    style={{ height: "40px" }}
                                                >
                                                    <option value="">Country</option>
                                                    {countryList &&
                                                        countryList.map((country, index) => (
                                                            <option key={index} value={country.id}>
                                                                {country.name}
                                                            </option>
                                                        ))}
                                                </select>
                                                {errors.address_country_id && (
                                                    <div className="text-danger">
                                                        {errors.address_country_id}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-lg-6">
                                                <input
                                                    type="number"
                                                    className="form-control mt-2"
                                                    id="zipcode"
                                                    value={zipcode}
                                                    onChange={(e) => setZipcode(e.target.value)}
                                                    readOnly={props.data.readonly}
                                                    placeholder="Zipcode"
                                                    style={{ height: "40px" }}
                                                />
                                                {errors.zipcode && (
                                                    <div className="text-danger">{errors.zipcode}</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer py-2 border-2 border-top">
                    <button
                        type="button"
                        onClick={onCloseRecipientModel}
                        className="btn btn-outline-secondary"
                    >
                        Cancel
                    </button>
                    {props.data.readonly === true ? (
                        ``
                    ) : (
                        <>
                            {id > 0 ? (
                                <button
                                    type="button"
                                    onClick={handleRecipientUpdate}
                                    className="btn-save px-2"
                                >
                                    Update
                                </button>
                            ) : (
                                <>
                                    <button
                                        type="button"
                                        onClick={handleRecipientAdd}
                                        className="btn btn-outline-primary"
                                    >
                                        Save &amp; Add Another
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleRecipientSave}
                                        className="btn btn-primary"
                                    >
                                        Save
                                    </button>
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ModifyRecipient;
